import getMixture from "./getMixture";
import createMixture from "./createMixture";
import updateMixture from "./updateMixture";
import deleteMixture from "./deleteMixture";

export { getMixture, createMixture, updateMixture, deleteMixture };

export default { getMixture, createMixture, updateMixture, deleteMixture };
